// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","description":"Na8LH8i6 m0"};